import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import main_de from './locales/de/main-de.json'
import main_fr from './locales/fr/main-fr.json'
import intro_de from './locales/de/intro-de.json'
import intro_fr from './locales/fr/intro-fr.json'
import worldChart_de from './locales/de/worldChart-de.json'
import worldChart_fr from './locales/fr/worldChart-fr.json'
import chChart_de from './locales/de/chChart-de.json'
import chChart_fr from './locales/fr/chChart-fr.json'
import evolutionChart_de from './locales/de/evolutionChart-de.json'
import evolutionChart_fr from './locales/fr/evolutionChart-fr.json'


i18n.use(initReactI18next).init({
  resources: {
    de: {
      main: main_de,
      intro: intro_de,
      worldChart: worldChart_de,
      chChart: chChart_de,
      evolutionChart: evolutionChart_de,
    },
    fr: {
      main: main_fr,
      intro: intro_fr,
      worldChart: worldChart_fr,
      chChart: chChart_fr,
      evolutionChart: evolutionChart_fr,
    },
  },
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
